import { render } from "./Footer.vue?vue&type=template&id=0d725df0"
const script = {}
script.render = render

export default script